import queryString from "query-string";

/**
 * Builds the standard file name for participant documents without extension:
 * "{Sencenet}_{Nombre-Del-Participante}_{RUT}"
 */
export const buildParticipantFileNameWithoutExtension = (
  sencenet?: string | null,
  participantName?: string | null,
  rut?: string | null,
): string => {
  if (participantName) {
    participantName = participantName.split(" ").filter(Boolean).join("-");
  }

  const name = [sencenet, participantName, rut]
    .filter(Boolean)
    .map((part) =>
      String(part)
        .trim()
        .replace(/[/\\:*?"<>|]/g, ""),
    )
    .join("_");
  return name || "documento";
};

/**
 * Builds the standard file name for participant documents:
 * "{Sencenet}_{Nombre-Del-Participante}_{RUT}.{extension}"
 */
export const buildParticipantFileName = (
  sencenet?: string | null,
  participantName?: string | null,
  rut?: string | null,
  extension: string = "pdf",
): string => {
  const nameWithoutExtension = buildParticipantFileNameWithoutExtension(
    sencenet,
    participantName,
    rut,
  );

  return `${nameWithoutExtension}.${extension}`;
};

/**
 * Returns the raw file extension from a signed file URL (its "ext" query param)
 */
export const getRawFileExtension = (
  url?: string | null,
  fallback: string = "pdf",
): string => {
  if (!url) return fallback;
  const { query } = queryString.parseUrl(url);
  return (query.ext as string) || fallback;
};

/**
 * Triggers a browser download of a base64 encoded file with a given filename
 */
export const downloadBase64File = (
  base64: string,
  filename: string,
  mimeType: string = "application/pdf",
): void => {
  const byteCharacters = window.atob(base64);
  const bytes = new Uint8Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i += 1) {
    bytes[i] = byteCharacters.charCodeAt(i);
  }

  const blob = new Blob([bytes], { type: mimeType });
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
};
